'use strict';

var RecommendationEntryDirective = function RecommendationEntryDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'RecommendationEntryController',
    template: require('../templates/recommendation-entry.html'),
    scope: {
      entry: '=',
      gridSettings: '=',
      screenState: '='
    }
  };
};
RecommendationEntryDirective.$inject = [];
module.exports = RecommendationEntryDirective;